import { useState } from 'react';
import Cookies from 'universal-cookie';
import { days } from 'common/utils';
import { SearchType } from 'contexts/searchParams';

const cookies = new Cookies();
const noticeHideKey = 'hidef';

const filterSaveCookieNameMap = new Map([
  [SearchType.DOMESTIC, 'savedof'],
  [SearchType.INTERNATIONAL, 'saveinf'],
]);

const useFilterSaveCookies = (
  initialFilterState: boolean,
  searchType: SearchType,
): [boolean, () => void] => {
  const saveKey = filterSaveCookieNameMap.get(searchType);
  if (saveKey === undefined) return [false, () => {}];

  const value = cookies.get(saveKey);

  const isSave = value ? Boolean(+value) : initialFilterState;

  const [save, toggleSave] = useState(isSave);

  const toggleFilterSave = () => {
    cookies.set(saveKey, +!save);
    toggleSave(prev => !prev);
  };

  return [save, toggleFilterSave];
};

const useFilterNoticeHide = (searchType: SearchType): [boolean, () => void] => {
  const key = `${noticeHideKey}${searchType}`;
  const isHide = cookies.get(key);
  const isHideNotice = Boolean(+isHide);

  const hideNotice = () =>
    cookies.set(key, +true, { expires: days().endOf('day').toDate() });

  return [isHideNotice, hideNotice];
};

export { useFilterNoticeHide, useFilterSaveCookies };
